import { getAvatarBackgroundColor } from "../../../../components/@loadAvatar/loadAvatarUtil";

// tooltip 弹窗额外样式
const overlayInnerStyle = {
    lineHeight: '0.2rem',
    color: '#111010',
    fontSize: '0.14rem',
};

const getUserAvatarStyle = (width: number, userId: string) => {
    return {
        backgroundColor: getAvatarBackgroundColor(userId),
        height: `${width / 100}rem`,
        width: `${width / 100}rem`,
        lineHeight: `${width / 100}rem`,
        fontSize: `${width / 150}rem`,
        borderRadius: '50%',
    };
};
export { overlayInnerStyle, getUserAvatarStyle };
